.searchTypes {
  display: flex;
  flex-direction: row;
  gap: 0px;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.searchType {
  flex: 0 0 calc(100% / 6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 4px;
  background-color: var(--color-bg-0);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semi-bold);
  color: var(--color-text-1);
  transition:
    transform 0.2s,
    box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px var(--color-shadow-1);
  }
}

.searchTypeIcon {
  width: 36px;
  height: 36px;
}

@media (--view-sm) {
  .searchTypes {
    gap: 16px;
  }
  .searchType {
    flex: 1;
    padding: 16px 0;
    font-size: var(--font-size-md);
    border-radius: var(--border-radius-sm);
  }
}
